module.exports = __webpack_public_path__ + "img/skew.cbda524e.svg";